<div class="activity-feed">

  <div class="feed-header">
    <mat-icon>timeline</mat-icon>
    Activity Timeline
  </div>

  <!-- Loading skeleton -->
  <div *ngIf="loading && activities.length === 0" fxLayoutAlign="center center" style="padding:24px">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <!-- Timeline -->
  <div class="timeline" *ngIf="activities.length > 0">
    <div *ngFor="let activity of activities; trackBy: trackById" class="timeline-item">

      <!-- Icon bubble -->
      <div class="timeline-icon" [style.background]="getActivityColor(activity)">
        <mat-icon>{{ getActivityIcon(activity) }}</mat-icon>
      </div>

      <!-- Content -->
      <div class="timeline-content">
        <div class="activity-meta" fxLayout="row" fxLayoutAlign="space-between center">
          <span class="activity-type">{{ activity.activityType || activity.type }}</span>
          <span class="activity-time"
                [matTooltip]="activity.createdDate | date:'dd MMM yyyy, h:mm:ss a'">
            {{ activity.createdDate | date:'dd MMM, h:mm a' }}
          </span>
        </div>

        <div class="activity-actor">
          <mat-icon class="actor-icon">person</mat-icon>
          {{ activity.owner || activity.updatedBy || 'System' }}
        </div>

        <div *ngIf="activity.notes" class="activity-notes">
          {{ activity.notes | slice:0:300 }}
          <span *ngIf="activity.notes?.length > 300" class="ellipsis">…</span>
        </div>

        <div *ngIf="activity.subject" class="activity-subject">
          <mat-icon class="subject-icon">subject</mat-icon>
          {{ activity.subject }}
        </div>

        <div *ngIf="activity.phoneCallOutcome" class="activity-outcome">
          <mat-icon>radio_button_checked</mat-icon>
          Outcome: {{ activity.phoneCallOutcome }}
        </div>
      </div>

    </div><!-- /timeline-item -->
  </div><!-- /timeline -->

  <!-- Load More -->
  <div *ngIf="page + 1 < totalPages" fxLayoutAlign="center center" style="margin-top:16px">
    <button mat-stroked-button (click)="loadMore()">
      <mat-spinner *ngIf="loading" diameter="16" style="display:inline-block"></mat-spinner>
      <span *ngIf="!loading">Load more activities</span>
    </button>
  </div>

  <!-- Empty -->
  <div *ngIf="!loading && activities.length === 0" class="empty-state">
    <mat-icon>history</mat-icon>
    <p>No activities recorded yet.</p>
  </div>

</div>
